var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('embed',{attrs:{"src":_vm.format_path,"type":"application/pdf","width":"950","height":"600"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }